"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AppApisV1InventoriesListInventories200Response = _interopRequireDefault(require("../model/AppApisV1InventoriesListInventories200Response"));

var _AppApisV1InventoriesUpdateInventoryProductQuantityRequest = _interopRequireDefault(require("../model/AppApisV1InventoriesUpdateInventoryProductQuantityRequest"));

var _AppApisV1InventoriesUpdateInventoryRequest = _interopRequireDefault(require("../model/AppApisV1InventoriesUpdateInventoryRequest"));

var _Errors = _interopRequireDefault(require("../model/Errors"));

var _GetLatestInventoryProductRequest = _interopRequireDefault(require("../model/GetLatestInventoryProductRequest"));

var _GetLatestInventoryProductsRequest = _interopRequireDefault(require("../model/GetLatestInventoryProductsRequest"));

var _Inventory = _interopRequireDefault(require("../model/Inventory"));

var _InventoryCreationRequest = _interopRequireDefault(require("../model/InventoryCreationRequest"));

var _InventoryProduct = _interopRequireDefault(require("../model/InventoryProduct"));

var _InventoryProductCreationRequest = _interopRequireDefault(require("../model/InventoryProductCreationRequest"));

var _InventoryProductUpdateRequest = _interopRequireDefault(require("../model/InventoryProductUpdateRequest"));

var _InventoryUpdateQuantitiesRequestInner = _interopRequireDefault(require("../model/InventoryUpdateQuantitiesRequestInner"));

var _LatestInventoryProduct = _interopRequireDefault(require("../model/LatestInventoryProduct"));

var _NextInventory = _interopRequireDefault(require("../model/NextInventory"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
* Inventories service.
* @module api/InventoriesApi
* @version 1.126
*/
var InventoriesApi = /*#__PURE__*/function () {
  /**
  * Constructs a new InventoriesApi. 
  * @alias module:api/InventoriesApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function InventoriesApi(apiClient) {
    _classCallCheck(this, InventoriesApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create a new inventory
   * **scope**: inventories:write 
   * @param {module:model/InventoryCreationRequest} inventoryCreationRequest Inventory
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Inventory} and HTTP response
   */


  _createClass(InventoriesApi, [{
    key: "appApisV1InventoriesCreateInventoryWithHttpInfo",
    value: function appApisV1InventoriesCreateInventoryWithHttpInfo(inventoryCreationRequest) {
      var postBody = inventoryCreationRequest; // verify the required parameter 'inventoryCreationRequest' is set

      if (inventoryCreationRequest === undefined || inventoryCreationRequest === null) {
        throw new Error("Missing the required parameter 'inventoryCreationRequest' when calling appApisV1InventoriesCreateInventory");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Inventory["default"];
      return this.apiClient.callApi('/inventories', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new inventory
     * **scope**: inventories:write 
     * @param {module:model/InventoryCreationRequest} inventoryCreationRequest Inventory
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Inventory}
     */

  }, {
    key: "appApisV1InventoriesCreateInventory",
    value: function appApisV1InventoriesCreateInventory(inventoryCreationRequest) {
      return this.appApisV1InventoriesCreateInventoryWithHttpInfo(inventoryCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Create a new inventory products for a given product_uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {module:model/InventoryProductCreationRequest} inventoryProductCreationRequest Product to add to the inventory
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InventoryProduct>} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesCreateInventoryProductWithHttpInfo",
    value: function appApisV1InventoriesCreateInventoryProductWithHttpInfo(inventoryUuid, inventoryProductCreationRequest) {
      var postBody = inventoryProductCreationRequest; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesCreateInventoryProduct");
      } // verify the required parameter 'inventoryProductCreationRequest' is set


      if (inventoryProductCreationRequest === undefined || inventoryProductCreationRequest === null) {
        throw new Error("Missing the required parameter 'inventoryProductCreationRequest' when calling appApisV1InventoriesCreateInventoryProduct");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_InventoryProduct["default"]];
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new inventory products for a given product_uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {module:model/InventoryProductCreationRequest} inventoryProductCreationRequest Product to add to the inventory
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InventoryProduct>}
     */

  }, {
    key: "appApisV1InventoriesCreateInventoryProduct",
    value: function appApisV1InventoriesCreateInventoryProduct(inventoryUuid, inventoryProductCreationRequest) {
      return this.appApisV1InventoriesCreateInventoryProductWithHttpInfo(inventoryUuid, inventoryProductCreationRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete inventory
     * **scope**: inventories:admin 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1InventoriesDeleteInventoryWithHttpInfo",
    value: function appApisV1InventoriesDeleteInventoryWithHttpInfo(inventoryUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesDeleteInventory");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/inventories/{inventory_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete inventory
     * **scope**: inventories:admin 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1InventoriesDeleteInventory",
    value: function appApisV1InventoriesDeleteInventory(inventoryUuid) {
      return this.appApisV1InventoriesDeleteInventoryWithHttpInfo(inventoryUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Delete an inventory product given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1InventoriesDeleteInventoryProductWithHttpInfo",
    value: function appApisV1InventoriesDeleteInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesDeleteInventoryProduct");
      } // verify the required parameter 'inventoryProductUuid' is set


      if (inventoryProductUuid === undefined || inventoryProductUuid === null) {
        throw new Error("Missing the required parameter 'inventoryProductUuid' when calling appApisV1InventoriesDeleteInventoryProduct");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid,
        'inventory_product_uuid': inventoryProductUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products/{inventory_product_uuid}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Delete an inventory product given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1InventoriesDeleteInventoryProduct",
    value: function appApisV1InventoriesDeleteInventoryProduct(inventoryUuid, inventoryProductUuid) {
      return this.appApisV1InventoriesDeleteInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Generate inventory products
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Inventory} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesGenerateInventoryProductsWithHttpInfo",
    value: function appApisV1InventoriesGenerateInventoryProductsWithHttpInfo(inventoryUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesGenerateInventoryProducts");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Inventory["default"];
      return this.apiClient.callApi('/inventories/{inventory_uuid}/generate', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Generate inventory products
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Inventory}
     */

  }, {
    key: "appApisV1InventoriesGenerateInventoryProducts",
    value: function appApisV1InventoriesGenerateInventoryProducts(inventoryUuid) {
      return this.appApisV1InventoriesGenerateInventoryProductsWithHttpInfo(inventoryUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get inventory
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Inventory} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesGetInventoryWithHttpInfo",
    value: function appApisV1InventoriesGetInventoryWithHttpInfo(inventoryUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesGetInventory");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _Inventory["default"];
      return this.apiClient.callApi('/inventories/{inventory_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get inventory
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Inventory}
     */

  }, {
    key: "appApisV1InventoriesGetInventory",
    value: function appApisV1InventoriesGetInventory(inventoryUuid) {
      return this.appApisV1InventoriesGetInventoryWithHttpInfo(inventoryUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get inventory products given its uuid
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InventoryProduct} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesGetInventoryProductWithHttpInfo",
    value: function appApisV1InventoriesGetInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesGetInventoryProduct");
      } // verify the required parameter 'inventoryProductUuid' is set


      if (inventoryProductUuid === undefined || inventoryProductUuid === null) {
        throw new Error("Missing the required parameter 'inventoryProductUuid' when calling appApisV1InventoriesGetInventoryProduct");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid,
        'inventory_product_uuid': inventoryProductUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _InventoryProduct["default"];
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products/{inventory_product_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get inventory products given its uuid
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InventoryProduct}
     */

  }, {
    key: "appApisV1InventoriesGetInventoryProduct",
    value: function appApisV1InventoriesGetInventoryProduct(inventoryUuid, inventoryProductUuid) {
      return this.appApisV1InventoriesGetInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get next inventory
     * **scope**: inventories:read 
     * @param {String} locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/NextInventory} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesGetNextInventoryWithHttpInfo",
    value: function appApisV1InventoriesGetNextInventoryWithHttpInfo(locationUuid) {
      var postBody = null; // verify the required parameter 'locationUuid' is set

      if (locationUuid === undefined || locationUuid === null) {
        throw new Error("Missing the required parameter 'locationUuid' when calling appApisV1InventoriesGetNextInventory");
      }

      var pathParams = {};
      var queryParams = {
        'location_uuid': locationUuid
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _NextInventory["default"];
      return this.apiClient.callApi('/inventories/todo', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get next inventory
     * **scope**: inventories:read 
     * @param {String} locationUuid Location uuid
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/NextInventory}
     */

  }, {
    key: "appApisV1InventoriesGetNextInventory",
    value: function appApisV1InventoriesGetNextInventory(locationUuid) {
      return this.appApisV1InventoriesGetNextInventoryWithHttpInfo(locationUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get inventories
     * **scope**: inventories:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Date} opts.inventoryDay 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AppApisV1InventoriesListInventories200Response} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesListInventoriesWithHttpInfo",
    value: function appApisV1InventoriesListInventoriesWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = null;
      var pathParams = {};
      var queryParams = {
        'location_uuid': opts['locationUuid'],
        'inventory_day': opts['inventoryDay'],
        'page': opts['page'],
        'per_page': opts['perPage'],
        'order_by': opts['orderBy'],
        'descending': opts['descending']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AppApisV1InventoriesListInventories200Response["default"];
      return this.apiClient.callApi('/inventories', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get inventories
     * **scope**: inventories:read 
     * @param {Object} opts Optional parameters
     * @param {String} opts.locationUuid Location uuid
     * @param {Date} opts.inventoryDay 
     * @param {Number} opts.page 
     * @param {Number} opts.perPage 
     * @param {module:model/String} opts.orderBy Order by
     * @param {Boolean} opts.descending 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AppApisV1InventoriesListInventories200Response}
     */

  }, {
    key: "appApisV1InventoriesListInventories",
    value: function appApisV1InventoriesListInventories(opts) {
      return this.appApisV1InventoriesListInventoriesWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * List inventory products
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/InventoryProduct>} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesListInventoryProductsWithHttpInfo",
    value: function appApisV1InventoriesListInventoryProductsWithHttpInfo(inventoryUuid) {
      var postBody = null; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesListInventoryProducts");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_InventoryProduct["default"]];
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * List inventory products
     * **scope**: inventories:read 
     * @param {String} inventoryUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/InventoryProduct>}
     */

  }, {
    key: "appApisV1InventoriesListInventoryProducts",
    value: function appApisV1InventoriesListInventoryProducts(inventoryUuid) {
      return this.appApisV1InventoriesListInventoryProductsWithHttpInfo(inventoryUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update inventory comments
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {module:model/AppApisV1InventoriesUpdateInventoryRequest} appApisV1InventoriesUpdateInventoryRequest Inventory comments
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Inventory} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryWithHttpInfo",
    value: function appApisV1InventoriesUpdateInventoryWithHttpInfo(inventoryUuid, appApisV1InventoriesUpdateInventoryRequest) {
      var postBody = appApisV1InventoriesUpdateInventoryRequest; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesUpdateInventory");
      } // verify the required parameter 'appApisV1InventoriesUpdateInventoryRequest' is set


      if (appApisV1InventoriesUpdateInventoryRequest === undefined || appApisV1InventoriesUpdateInventoryRequest === null) {
        throw new Error("Missing the required parameter 'appApisV1InventoriesUpdateInventoryRequest' when calling appApisV1InventoriesUpdateInventory");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _Inventory["default"];
      return this.apiClient.callApi('/inventories/{inventory_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update inventory comments
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {module:model/AppApisV1InventoriesUpdateInventoryRequest} appApisV1InventoriesUpdateInventoryRequest Inventory comments
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Inventory}
     */

  }, {
    key: "appApisV1InventoriesUpdateInventory",
    value: function appApisV1InventoriesUpdateInventory(inventoryUuid, appApisV1InventoriesUpdateInventoryRequest) {
      return this.appApisV1InventoriesUpdateInventoryWithHttpInfo(inventoryUuid, appApisV1InventoriesUpdateInventoryRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update an inventory product given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @param {module:model/InventoryProductUpdateRequest} inventoryProductUpdateRequest Inventory product update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/InventoryProduct} and HTTP response
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProductWithHttpInfo",
    value: function appApisV1InventoriesUpdateInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid, inventoryProductUpdateRequest) {
      var postBody = inventoryProductUpdateRequest; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesUpdateInventoryProduct");
      } // verify the required parameter 'inventoryProductUuid' is set


      if (inventoryProductUuid === undefined || inventoryProductUuid === null) {
        throw new Error("Missing the required parameter 'inventoryProductUuid' when calling appApisV1InventoriesUpdateInventoryProduct");
      } // verify the required parameter 'inventoryProductUpdateRequest' is set


      if (inventoryProductUpdateRequest === undefined || inventoryProductUpdateRequest === null) {
        throw new Error("Missing the required parameter 'inventoryProductUpdateRequest' when calling appApisV1InventoriesUpdateInventoryProduct");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid,
        'inventory_product_uuid': inventoryProductUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _InventoryProduct["default"];
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products/{inventory_product_uuid}', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update an inventory product given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @param {module:model/InventoryProductUpdateRequest} inventoryProductUpdateRequest Inventory product update request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/InventoryProduct}
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProduct",
    value: function appApisV1InventoriesUpdateInventoryProduct(inventoryUuid, inventoryProductUuid, inventoryProductUpdateRequest) {
      return this.appApisV1InventoriesUpdateInventoryProductWithHttpInfo(inventoryUuid, inventoryProductUuid, inventoryProductUpdateRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update an inventory product quantity given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @param {module:model/AppApisV1InventoriesUpdateInventoryProductQuantityRequest} appApisV1InventoriesUpdateInventoryProductQuantityRequest Inventory product quantity request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProductQuantityWithHttpInfo",
    value: function appApisV1InventoriesUpdateInventoryProductQuantityWithHttpInfo(inventoryUuid, inventoryProductUuid, appApisV1InventoriesUpdateInventoryProductQuantityRequest) {
      var postBody = appApisV1InventoriesUpdateInventoryProductQuantityRequest; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesUpdateInventoryProductQuantity");
      } // verify the required parameter 'inventoryProductUuid' is set


      if (inventoryProductUuid === undefined || inventoryProductUuid === null) {
        throw new Error("Missing the required parameter 'inventoryProductUuid' when calling appApisV1InventoriesUpdateInventoryProductQuantity");
      } // verify the required parameter 'appApisV1InventoriesUpdateInventoryProductQuantityRequest' is set


      if (appApisV1InventoriesUpdateInventoryProductQuantityRequest === undefined || appApisV1InventoriesUpdateInventoryProductQuantityRequest === null) {
        throw new Error("Missing the required parameter 'appApisV1InventoriesUpdateInventoryProductQuantityRequest' when calling appApisV1InventoriesUpdateInventoryProductQuantity");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid,
        'inventory_product_uuid': inventoryProductUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/inventories/{inventory_uuid}/products/{inventory_product_uuid}/quantities', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update an inventory product quantity given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {String} inventoryProductUuid 
     * @param {module:model/AppApisV1InventoriesUpdateInventoryProductQuantityRequest} appApisV1InventoriesUpdateInventoryProductQuantityRequest Inventory product quantity request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProductQuantity",
    value: function appApisV1InventoriesUpdateInventoryProductQuantity(inventoryUuid, inventoryProductUuid, appApisV1InventoriesUpdateInventoryProductQuantityRequest) {
      return this.appApisV1InventoriesUpdateInventoryProductQuantityWithHttpInfo(inventoryUuid, inventoryProductUuid, appApisV1InventoriesUpdateInventoryProductQuantityRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Update inventory products quantities given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {Array.<module:model/InventoryUpdateQuantitiesRequestInner>} inventoryUpdateQuantitiesRequestInner Update quantities request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProductsQuantitiesWithHttpInfo",
    value: function appApisV1InventoriesUpdateInventoryProductsQuantitiesWithHttpInfo(inventoryUuid, inventoryUpdateQuantitiesRequestInner) {
      var postBody = inventoryUpdateQuantitiesRequestInner; // verify the required parameter 'inventoryUuid' is set

      if (inventoryUuid === undefined || inventoryUuid === null) {
        throw new Error("Missing the required parameter 'inventoryUuid' when calling appApisV1InventoriesUpdateInventoryProductsQuantities");
      } // verify the required parameter 'inventoryUpdateQuantitiesRequestInner' is set


      if (inventoryUpdateQuantitiesRequestInner === undefined || inventoryUpdateQuantitiesRequestInner === null) {
        throw new Error("Missing the required parameter 'inventoryUpdateQuantitiesRequestInner' when calling appApisV1InventoriesUpdateInventoryProductsQuantities");
      }

      var pathParams = {
        'inventory_uuid': inventoryUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/inventories/{inventory_uuid}/update-quantities', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Update inventory products quantities given its uuid
     * **scope**: inventories:write 
     * @param {String} inventoryUuid 
     * @param {Array.<module:model/InventoryUpdateQuantitiesRequestInner>} inventoryUpdateQuantitiesRequestInner Update quantities request
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */

  }, {
    key: "appApisV1InventoriesUpdateInventoryProductsQuantities",
    value: function appApisV1InventoriesUpdateInventoryProductsQuantities(inventoryUuid, inventoryUpdateQuantitiesRequestInner) {
      return this.appApisV1InventoriesUpdateInventoryProductsQuantitiesWithHttpInfo(inventoryUuid, inventoryUpdateQuantitiesRequestInner).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get latest product stock saved within inventories
     * **scope**: inventories:read 
     * @param {module:model/GetLatestInventoryProductRequest} getLatestInventoryProductRequest The query parameters used to retrieve the latest stock of a product within a kitchen inventory 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/LatestInventoryProduct} and HTTP response
     */

  }, {
    key: "appApisV1InventoryProductsGetLatestInventoryProductWithHttpInfo",
    value: function appApisV1InventoryProductsGetLatestInventoryProductWithHttpInfo(getLatestInventoryProductRequest) {
      var postBody = getLatestInventoryProductRequest; // verify the required parameter 'getLatestInventoryProductRequest' is set

      if (getLatestInventoryProductRequest === undefined || getLatestInventoryProductRequest === null) {
        throw new Error("Missing the required parameter 'getLatestInventoryProductRequest' when calling appApisV1InventoryProductsGetLatestInventoryProduct");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _LatestInventoryProduct["default"];
      return this.apiClient.callApi('/inventory-products/get-latest-stock', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get latest product stock saved within inventories
     * **scope**: inventories:read 
     * @param {module:model/GetLatestInventoryProductRequest} getLatestInventoryProductRequest The query parameters used to retrieve the latest stock of a product within a kitchen inventory 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/LatestInventoryProduct}
     */

  }, {
    key: "appApisV1InventoryProductsGetLatestInventoryProduct",
    value: function appApisV1InventoryProductsGetLatestInventoryProduct(getLatestInventoryProductRequest) {
      return this.appApisV1InventoryProductsGetLatestInventoryProductWithHttpInfo(getLatestInventoryProductRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Get latest product stocks associated to a purchase order within inventories
     * **scope**: inventories:read 
     * @param {module:model/GetLatestInventoryProductsRequest} getLatestInventoryProductsRequest The query parameters used to retrieve the latest stocks associated to a purchase order within a kitchen inventory 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/LatestInventoryProduct>} and HTTP response
     */

  }, {
    key: "appApisV1InventoryProductsGetLatestInventoryProductsWithHttpInfo",
    value: function appApisV1InventoryProductsGetLatestInventoryProductsWithHttpInfo(getLatestInventoryProductsRequest) {
      var postBody = getLatestInventoryProductsRequest; // verify the required parameter 'getLatestInventoryProductsRequest' is set

      if (getLatestInventoryProductsRequest === undefined || getLatestInventoryProductsRequest === null) {
        throw new Error("Missing the required parameter 'getLatestInventoryProductsRequest' when calling appApisV1InventoryProductsGetLatestInventoryProducts");
      }

      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = [_LatestInventoryProduct["default"]];
      return this.apiClient.callApi('/inventory-products/get-latest-stocks', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Get latest product stocks associated to a purchase order within inventories
     * **scope**: inventories:read 
     * @param {module:model/GetLatestInventoryProductsRequest} getLatestInventoryProductsRequest The query parameters used to retrieve the latest stocks associated to a purchase order within a kitchen inventory 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/LatestInventoryProduct>}
     */

  }, {
    key: "appApisV1InventoryProductsGetLatestInventoryProducts",
    value: function appApisV1InventoryProductsGetLatestInventoryProducts(getLatestInventoryProductsRequest) {
      return this.appApisV1InventoryProductsGetLatestInventoryProductsWithHttpInfo(getLatestInventoryProductsRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return InventoriesApi;
}();

exports["default"] = InventoriesApi;